export default {"src":"/_next/static/media/kale.1fcaf861.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};